/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  app.Filters.CheckboxFilter = app.Filters.Checkbox.extend({
    viewClass: app.Filters.CheckboxFilterView,
    toQuery: function (obj) {
      if (this.get('value')) {
        obj[this.get('object').name] = 1;
      }
      return obj;
    }
  });
})();

}.call(window));